import React from "react";
import {alertColour} from "../../../../style/styleConsts";
import styled from "styled-components";
import {useSelector} from "react-redux";

const Container = styled.div`
    display: flex;
    background-color: ${alertColour};
    color: white;
`;

export const WarningBanner = styled.div`
    position: fixed;
    width: 100%; 
    top: 0;
    background-color: ${alertColour};
    padding: 10px 20px;
    z-index: 999;
`;

function getErrorMessage(subscriptions) {
    const failedSubscription = Object.values(subscriptions).find(subscription => subscription.hasFailed);
    if (failedSubscription) {
        return "WARNING: Failed to load data.";
    }
    const staleSubscription = Object.values(subscriptions).find(subscription => subscription.isStale);
    if (staleSubscription) {
        return "WARNING: Connection lost. Data may be stale.";
    }
    return null;
}

const Warnings = ({}) => {
    const subscriptions = useSelector(state => state.subscriptions);
    const errorMessage = getErrorMessage(subscriptions);
    if (!errorMessage)
        return null;
    return (
        <Container>
            <WarningBanner>{errorMessage}</WarningBanner>
        </Container>
    );
};

export default Warnings;
